import {oRender_ThreeEngine} from "./render_three";

function oRenderEngine(engine) {
  this.engine = engine;
}

oRenderEngine.prototype = {
  init: function () {
    // 初始化三维
    this.three = new oRender_ThreeEngine(this.engine);

    // 渲染模板
    this.engine.template.render();

    this.engine.tips.debug("[RenderEngine] " + this.engine.router.get().path);
  }
}

export {
  oRenderEngine
}





// WEBPACK FOOTER //
// ./src/assets/octopus/engine/render.js